<img style="width:29px; height: 29px;" class="process-close" (click)="onClose()" src="./assets/img/close.png" alt="close button"/>

<div class="modal-process_content">
    <h2>Tienes un proceso de {{data.processConcept}} para tu <strong>{{data.carBrand}}-{{data.carSubBrand}}</strong> en curso!</h2>
    <h3>¿Quieres revisar su estatus?</h3>
    <button class="acept-btn" (click)="toProcess()" mat-raised-button>Aceptar</button>
</div>